class RangeFactory {
  create(from, to) {
    const numbers = [];
    for (let number = from; number <= to; number++) {
      numbers.push(number);
    }
    return numbers;
  }
}
const rangeFactory = new RangeFactory();
export { rangeFactory };